import { Alert, AlertIcon, Box, Button, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export function ListFiltersActiveAlert({ show, onClear }) {
  const { t } = useTranslation();
  if (!show) return null;

  return (
    <Alert status="info" variant="subtle" borderRadius="md" mb={4}>
      <AlertIcon mt={0.5} />
      <Box flex="1">
        <Flex
          direction={{ base: "column", sm: "row" }}
          align={{ sm: "center" }}
          justify="space-between"
          gap={3}
        >
          <Text fontSize="sm">{t("system.labels.list-filtered-hint")}</Text>
          <Button
            size="sm"
            variant="outline"
            colorScheme="blue"
            alignSelf={{ base: "flex-start", sm: "center" }}
            flexShrink={0}
            onClick={onClear}
          >
            {t("system.actions.clear-filters")}
          </Button>
        </Flex>
      </Box>
    </Alert>
  );
}
